import React, { useEffect, useRef } from 'react';
interface ParticleBackgroundProps {
  className?: string;
}
export const ParticleBackground: React.FC<ParticleBackgroundProps> = ({
  className
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    // Set canvas dimensions
    const setCanvasDimensions = () => {
      const devicePixelRatio = window.devicePixelRatio || 1;
      const rect = canvas.getBoundingClientRect();
      canvas.width = rect.width * devicePixelRatio;
      canvas.height = rect.height * devicePixelRatio;
      ctx.scale(devicePixelRatio, devicePixelRatio);
    };
    setCanvasDimensions();
    window.addEventListener('resize', setCanvasDimensions);
    // Create particles with subtle glow effect
    const particleCount = Math.floor(canvas.width * canvas.height / 15000);
    const particles: Array<{
      x: number;
      y: number;
      size: number;
      speed: number;
      opacity: number;
      pulse: number;
      maxOpacity: number;
      phaseOffset: number;
    }> = [];
    for (let i = 0; i < particleCount; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        size: Math.random() * 4 + 2,
        speed: Math.random() * 0.1 + 0.02,
        opacity: Math.random() * 0.15 + 0.05,
        pulse: Math.random() * 0.001 + 0.0005,
        maxOpacity: Math.random() * 0.2 + 0.1,
        phaseOffset: Math.random() * Math.PI * 2
      });
    }
    // Animation loop with subtle glow
    let animationFrameId: number;
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      const time = Date.now();
      // Update and draw particles with heavy blur for glow effect
      particles.forEach(particle => {
        particle.y -= particle.speed;
        const pulseValue = Math.sin(time * particle.pulse + particle.phaseOffset) * 0.5 + 0.5;
        particle.opacity = particle.maxOpacity * pulseValue * 0.6;
        const drift = Math.sin(time * 0.0003 + particle.phaseOffset) * 0.5;
        const currentX = particle.x + drift;
        if (particle.y < -10) {
          particle.y = canvas.height + 10;
          particle.x = Math.random() * canvas.width;
        }
        // Draw with extensive blur for subtle glow
        ctx.beginPath();
        ctx.arc(currentX, particle.y, particle.size, 0, Math.PI * 2);
        const gradient = ctx.createRadialGradient(currentX, particle.y, 0, currentX, particle.y, particle.size * 6);
        gradient.addColorStop(0, `rgba(234, 246, 255, ${particle.opacity * 0.8})`);
        gradient.addColorStop(0.3, `rgba(234, 246, 255, ${particle.opacity * 0.4})`);
        gradient.addColorStop(1, 'rgba(234, 246, 255, 0)');
        ctx.fillStyle = gradient;
        ctx.fill();
      });
      animationFrameId = requestAnimationFrame(animate);
    };
    animate();
    // Cleanup
    return () => {
      window.removeEventListener('resize', setCanvasDimensions);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);
  return <canvas ref={canvasRef} className={`absolute inset-0 w-full h-full ${className}`} data-id="element-131" />;
};